import { gql } from '@apollo/client';

export type QueryResult = {
  request: {
    id: string;
    profile: Profile;
  };
};

export type Profile = {
  id: string;
  generalLifeInsurances: Insurance[];
  nursingMedicalInsurances: Insurance[];
  individualAnnuityInsurances: Insurance[];
  earthquakeInsurances: Insurance[];
  socialInsurances: Insurance[];
  premium?: Insurance;
  housingLoan?: Insurance;
};

type Insurance = {
  id: string;
};

export const INSURANCE_STATUSES_FRAGMENT = gql`
  fragment InsuranceStatusesFragment on Profile {
    generalLifeInsurances {
      id
    }
    nursingMedicalInsurances {
      id
    }
    individualAnnuityInsurances {
      id
    }
    earthquakeInsurances {
      id
    }
    socialInsurances {
      id
    }
    premium {
      id
    }
    housingLoan {
      id
    }
  }
`;

export const FETCH_INSURANCE_STATUSES = gql`
  query insuranceStatuses {
    request {
      id
      profile {
        id
        ...InsuranceStatusesFragment
      }
    }
  }
  ${INSURANCE_STATUSES_FRAGMENT}
`;
